import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space, theme } from "antd"
import React, { useEffect, useState } from "react";
import { requiredItem, TYPE_COMMISSION, TYPE_MODAL } from "../../../constants/constants";
import { formatInputNumber, parseInputNumber } from "../../../utils/funcHelper";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";

const ModalAddAndEdit = ({ visible, onCancel, onSave, data, title, type, listService, listPosition }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const [typeCommission, setTypeCommission] = useState(null);
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        if (type === TYPE_MODAL.ADD) {
            onSave(values);
        } else {
            let tempData = {...values};
            tempData.id = data.id;
            onSave(tempData);
        }
    };
    
    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            form.setFieldsValue({
                ...data
            });
        } else {
            form.resetFields();
        }
    }, [data, type, visible]);

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT && listService?.length > 0) {
            form.setFieldsValue({
                service_id: data?.service_id?.toString(),
            });
        }
        if (type === TYPE_MODAL.EDIT && listService?.length > 0) {
            form.setFieldsValue({
                position_id: data?.position_id?.toString(),
            });
        }
        
    }, [listService, visible, listPosition]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={14}>
                        <Form.Item
                            label="Chọn dịch vụ"
                            name="service_id"
                            rules={requiredItem}
                        >
                            <Select 
                                className="cus-height-40"
                                placeholder="Chọn dịch vụ"
                                options={listService || []}
                                showSearch
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        <Form.Item
                            label="Chọn chức vụ"
                            name="position_id"
                            rules={requiredItem}
                        >
                            <Select 
                                className="cus-height-40"
                                placeholder="Chọn chức vụ"
                                options={listPosition || []}
                                showSearch
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Chọn cách tính"
                            name="commission_type"
                            rules={requiredItem}
                        >
                            <Select 
                                className="cus-height-40"
                                placeholder="Chọn loại"
                                options={TYPE_COMMISSION.filter(item => item.value === 'fixed')}
                                showSearch
                                onChange={(value) => setTypeCommission(value)}
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={14}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 10 }}>
                        <Form.Item
                            label="Số tiền công tua"
                            name="commission_value"
                            rules={requiredItem}
                        >
                            <InputNumber 
                                className="input-number-cus-ant cus-height-40"
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                            />
                        </Form.Item>
                        {
                            typeCommission === 'percent' ? <div style={{color: token.colorTextSecondary, fontStyle: 'italic'}}>(%) trên giá dịch vụ</div>
                             : typeCommission === 'fixed' ? <div style={{color: token.colorTextSecondary, fontStyle: 'italic'}}>(VNĐ) trên mỗi lần thực hiện</div>
                             : null
                            
                        }
                        </div>
                        
                    </Col>
                    
                    
                </Row>
                
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalAddAndEdit);

